//export const API_URL: string = import.meta.env?.API_URL ?? ""
//export const API_URL: string = import.meta.env?.API_URL ?? (process.env as any).API_URL ?? ""
export const API_URL = process.env.BUN_PUBLIC_API_URL ?? "";

//console.log("ENV:", process.env.BUN_PUBLIC_API_URL)


// process.env -> sistema clásico de variables de entorno de Node/Bun
// existe en el servidor/runtime
//
// import.meta.env -> NO es estándar de JavaScript
// es una “API fake” que inventaron bundlers como Vite
